import { useTranslations } from "use-intl";
import type { ExpenseReimbursement, ExpenseStatus } from "@/types/expense";
import { EXPENSE_STATUS_DISPLAY } from "@/types/expense";
import type { Invoice } from "@/types/payments";

interface PaymentInvoiceOptions {
  payableId: string;
  paymentDate?: string;
  /** FIN-776: the FK, not the legacy `source_account` string — paymentGroupingUtils matches it against bank_accounts.id. */
  sourceAccountId?: string | null;
  /** Shown as the vendor when the expense has neither an employee nor a vendor. */
  fallbackVendor: string;
}

/** The unpaid invoice the payment confirmation modal pays an employee's expense through. */
export function expenseToPaymentInvoice(expense: ExpenseReimbursement, options: PaymentInvoiceOptions): Invoice {
  return {
    id: expense.financial_document_id,
    status: "unpaid",
    vendor: expense.employee_name || expense.vendor || options.fallbackVendor,
    amount: Number(expense.sek_amount ?? expense.amount ?? 0),
    fxRate: 1,
    currency: expense.sek_amount ? "SEK" : (expense.currency || "SEK"),
    dueDate: options.paymentDate || new Date().toISOString().split("T")[0],
    documentType: "expense",
    payableId: options.payableId,
    sourceAccountId: options.sourceAccountId ?? undefined,
  };
}

/** An expense status's badge, with its label in the language the app shows. */
export function useExpenseStatus() {
  const t = useTranslations("consultantExpenses.status");
  return (status: ExpenseStatus) => ({ ...EXPENSE_STATUS_DISPLAY[status], label: t(status) });
}
